import CardWithFields from "components/General/CardWithFields";
import CardDisclaimerBase from "components/General/CardDisclaimerBase";
import { stringFormattingToCurrency } from "js/formatting";
import { useTranslation, Trans } from "react-i18next";
import { isDeferredAnnuityPlanCode } from "js/utilities";

export default function ContractValues({ cashValues, policy }) {
  const { t } = useTranslation();
  const {
    accountValue,
    surrenderCharge,
    marketValueAdjustment,
    estimatedSurrenderValue,
    penaltyFreeAmount,
  } = cashValues;

  return (
    <CardWithFields
      additionalContent={
        <CardDisclaimerBase
          disclaimer={
            <>
              <Trans
                i18nKey={`${
                  !isDeferredAnnuityPlanCode(policy)
                    ? "AgentContractValues-card-disclaimer"
                    : "AgentContractValues-card-disclaimer-deferred-annuities"
                }`}
                components={{
                  break: <br />,
                }}
              />
            </>
          }
        />
      }
      ariaLabel={t("AgentContractValues-card-label")}
      cardTitle={t("AgentContractValues-card-title")}
      cardFields={[
        {
          title: t("AgentContractValues-card-title-1"),
          value: stringFormattingToCurrency(accountValue),
        },
        {
          title: t("AgentContractValues-card-title-2"),
          value: stringFormattingToCurrency(surrenderCharge),
        },
        {
          title: t("AgentContractValues-card-title-3"),
          value: stringFormattingToCurrency(marketValueAdjustment),
          hidden:
            !marketValueAdjustment || parseFloat(marketValueAdjustment) === 0,
        },
        {
          title: t("AgentContractValues-card-title-4"),
          value: stringFormattingToCurrency(estimatedSurrenderValue),
        },
        {
          title: t("AgentContractValues-card-title-5"),
          value: stringFormattingToCurrency(penaltyFreeAmount),
          hidden: parseFloat(surrenderCharge) === 0,
        },
      ]}
    />
  );
}
